import { createSlice } from "@reduxjs/toolkit";
import { getTalentsSelectorByPlantelThunk } from "./plantels.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,
};

const talentsSelectorSlice = createSlice({
  name: "talentsSelector",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTalentsSelectorByPlantelThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTalentsSelectorByPlantelThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(getTalentsSelectorByPlantelThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default talentsSelectorSlice.reducer;
